module.exports = __webpack_public_path__ + "img/2.e6be5a19.jpg";